import React, { useEffect } from "react";
import { UiButton, UiDrawer } from "../../../../components";
import { DownloadOutlined } from "@ant-design/icons";
import { userIcon } from "../../../../assets/images";
import { formatPhoneNumber } from "../../../../utils/appUtils";
import RejectLawyerModal from "../RejectLawyerModal";
import ApproveLawyerModal from "../ApproveLawyerModal";
import LawyerProfileReport from "../reports/lawyerProfileReport";
import { Badge, Modal, Tooltip } from "antd";
import "./style.scss";

const PrintLawyerProfileReport = React.forwardRef((props, ref) => {
    return <div ref={ref}>
        <LawyerProfileReport lawyerData={props?.lawyerData} profileImageUrl={props?.profileImageUrl} />
    </div>
});

const LawyerProfileView = ({
    isVisible,
    onClose,
    lawyerData,
    profileImageUrl,
    isRejectModalOpen,
    isApproveModalOpen,
    isProfileReportOpen,
    reportRef,
    handlePrint,
    isApproveRejectLoading,
    reason,
    handleReasonChange,
    handleRejectClick,
    handleApproveClick,
    handleRejectSubmit,
    handleApproveConfirm,
    handleCloseRejectModal,
    handleCloseApproveModal,
    handleDownloadReportClick,
    profileModalOpen,
    handleProfileModalOpen,
    handleProfileModalClose
}) => {
    useEffect(() => {
        if (isProfileReportOpen) {
            handlePrint();
        }
    }, [isProfileReportOpen, handlePrint]);

    if (!lawyerData) return null;

    const specializationList = Array.isArray(lawyerData?.specialization)
        ? lawyerData?.specialization?.filter((specializationItem) => Boolean(specializationItem))
        : [];
    const specializationCount = specializationList?.length || 0;
    const specializationPreview = specializationCount > 1
        ? `${specializationList?.[0]}...`
        : specializationList?.[0] || "Nil";
    const specializationTooltipTitle = specializationList?.join(", ");

    return (
        <>
        <UiDrawer
            open={isVisible}
            onClose={onClose}
            title="Lawyer Profile Details"
            width={600}
            footer={
                <div className="profile-footer">
                    <div className="footer-buttons">
                        <UiButton
                            className="download-report-btn"
                            onClick={handleDownloadReportClick}
                            icon={<DownloadOutlined />}
                            disabled={isApproveRejectLoading}
                        >
                            Download Report
                        </UiButton>
                        <UiButton
                            type="primary"
                            danger
                            className="reject-btn"
                            onClick={handleRejectClick}
                            loading={isApproveRejectLoading}
                            disabled={isApproveRejectLoading}
                        >
                            Reject
                        </UiButton>
                        <UiButton
                            type="primary"
                            className="approve-btn"
                            onClick={handleApproveClick}
                            loading={isApproveRejectLoading}
                            disabled={isApproveRejectLoading}
                        >
                            Approve
                        </UiButton>
                    </div>
                </div>
            }
        >
            <div className="lawyer-information">
                <div className="flexible" style={{ borderBottom: "1px solid #000" }}>
                    <div className="flexible">
                        {
                            !profileImageUrl || profileImageUrl?.includes("null") || profileImageUrl?.includes("undefined") ? <img src={userIcon} style={{ width: "50px", height: "50px", borderRadius: "50%", objectFit: "cover", cursor: "pointer" }} alt="" onClick={handleProfileModalOpen} /> : <img 
                                src={profileImageUrl} 
                                onClick={handleProfileModalOpen} 
                                alt="" 
                                className="profile-image" 
                                style={{ cursor: "pointer" }} 
                            />
                        }
                        <div>
                            <h3 className="lawerInfo-detail" style={{ marginTop: "15px"}}>
                                {lawyerData?.salutation} {lawyerData?.firstName} {lawyerData?.middleName} {lawyerData?.lastName}
                            </h3>
                        </div>
                    </div>
                </div>
                <div className="flexible">
                    <div>
                        <small className="information-header">Mobile Number</small>
                        <h3 className="lawerInfo-detail">{lawyerData?.mobileNumber ? formatPhoneNumber(lawyerData?.mobileNumber) : "Nil"}</h3>
                    </div>
                    <div>
                        <small className="information-header">E-mail Address</small>
                        <h3 className="lawerInfo-detail">{lawyerData?.email || "Nil"}</h3>
                    </div>
                </div>
            </div>
            <div className="lawyer-details">
                <div>
                    <div style={{ borderBottom: "1px solid #00000054", paddingBottom: "10px" }}>
                        <h3 className="lawerInfo-detail">Professional Details</h3>
                    </div>
                    <div className="flexible">
                        <div>
                            <small className="information-header">Bar council id</small>
                            <h3 className="lawerInfo-detail">{lawyerData?.barCouncilId || "Nil"}</h3>
                        </div>
                        <div>
                            <small className="information-header">
                                Specialization
                                {specializationCount > 1 ? (
                                    <Badge count={specializationCount} size="small" style={{ marginLeft: "6px" }} />
                                ) : null}
                            </small>
                            <h3 className="lawerInfo-detail">
                                {specializationCount > 1 ? (
                                    <Tooltip title={specializationTooltipTitle}>
                                        <span>{specializationPreview}</span>
                                    </Tooltip>
                                ) : specializationPreview}
                            </h3>
                        </div>
                        <div>
                            <small className="information-header">Experience</small>
                            <h3 className="lawerInfo-detail">{lawyerData?.experience ? `${lawyerData?.experience} Years` : "Nil"}</h3>
                        </div>
                        <div>
                            <small className="information-header">Qualification</small>
                            <h3 className="lawerInfo-detail">{lawyerData?.qualification || "Nil"}</h3>
                        </div>
                    </div>
                    <div style={{ padding: "10px 0px" }}>
                        <small className="information-header">Enrollment No</small>
                        <h3 className="lawerInfo-detail">{lawyerData?.enrollmentNo || "Nil"}</h3>
                    </div>
                </div>
                <div>
                    <div style={{ borderBottom: "1px solid #00000054", padding: "10px 0px" }}>
                        <h3 className="lawerInfo-detail">Personal Details</h3>
                    </div>
                    <div className="flexible">
                        <div style={{width:"50%"}}>
                            <small className="information-header">Address 1</small>
                            <h3 className="lawerInfo-detail">{lawyerData?.address1 || "Nil"}</h3>
                        </div>
                        <div style={{width:"50%"}}>
                            <small className="information-header">Address 2</small>
                            <h3 className="lawerInfo-detail">{lawyerData?.address2 || "Nil"}</h3>
                        </div>
                    </div>
                    <div className="flexible">
                        <div>
                            <small className="information-header">State</small>
                            <h3 className="lawerInfo-detail">{lawyerData?.state || "Nil"}</h3>
                        </div>
                        <div>
                            <small className="information-header">District</small>
                            <h3 className="lawerInfo-detail">{lawyerData?.district || "Nil"}</h3>
                        </div>
                        <div>
                            <small className="information-header">City</small>
                            <h3 className="lawerInfo-detail">{lawyerData?.city || "Nil"}</h3>
                        </div>
                        <div>
                            <small className="information-header">Pincode</small>
                            <h3 className="lawerInfo-detail">{lawyerData?.pincode || "Nil"}</h3>
                        </div>
                    </div>
                </div>

                <div>
                    <div style={{ borderBottom: "1px solid #00000054", padding: "10px 0px" }}>
                        <h3 className="lawerInfo-detail">Bio/About You</h3>
                    </div>
                    <div>
                        <p>{lawyerData?.aboutAs || "Nil"}</p>
                    </div>
                </div>
            </div>
            <RejectLawyerModal
                isVisible={isRejectModalOpen}
                onClose={handleCloseRejectModal}
                onSubmit={handleRejectSubmit}
                lawyerName={lawyerData?.lawyerName}
                isLoading={isApproveRejectLoading}
                reason={reason}
                handleReasonChange={handleReasonChange}
            />
            <ApproveLawyerModal
                isVisible={isApproveModalOpen}
                onClose={handleCloseApproveModal}
                onConfirm={handleApproveConfirm}
                lawyerName={lawyerData?.lawyerName}
                isLoading={isApproveRejectLoading}
            />
            <div style={{ display: "none" }}>
                <PrintLawyerProfileReport
                    ref={reportRef}
                    lawyerData={lawyerData}
                    profileImageUrl={profileImageUrl}
                />
            </div>
        </UiDrawer>
        <Modal 
            open={profileModalOpen} 
            onCancel={handleProfileModalClose} 
            footer={null} 
            centered 
            className="custom-image-modal"
            closeIcon={<span style={{ fontSize: 24, color: "#fff" }}>×</span>}
        >
            <div style={{ padding: "20px 0px" }}>
                {profileImageUrl ? (
                    <img 
                        src={profileImageUrl} 
                        alt={lawyerData?.lawyerName || "Lawyer"} 
                        style={{ width: "100%", height: "auto", borderRadius: "8px", objectFit: "cover" }} 
                    />
                ) : (
                    <div className="profile-avatar profile-placeholder" aria-hidden="true" style={{ width: "100%", height: "300px" }} />
                )}
            </div>
        </Modal>
        </>
    );
};

export default LawyerProfileView;